import { Input } from 'components/atoms';
import { FormInput } from 'components/molecules';
import LabelFormStep from 'components/templates/label-form-step/LabelFormStep';
import { useTranslation } from 'react-i18next';
import { useGetCountries } from 'services/enums';
import { getCountries } from 'utils/global/countries.utils';

const LabelSupervisorStep = () => {
  const { t } = useTranslation();

  const countries = useGetCountries();

  return (
    <LabelFormStep
      header={t('label.form.supervisor.header')}
      description={t('label.form.supervisor.description')}
    >
      <div className="flex w-full gap-2 ">
        <FormInput.Text
          name="legalSupervisorFirstName"
          label={t('input.label.firstName')}
          appBackground
          borderless
          fullWidth
        />
        <FormInput.Text
          name="legalSupervisorLastName"
          label={t('input.label.lastName')}
          appBackground
          borderless
          fullWidth
        />
      </div>
      <FormInput.Select
        name="legalSupervisorCountryAlfa2"
        label={t('input.label.country')}
        options={getCountries(countries.data)}
        borderless
        appBackground
        fullWidth
      />
      <FormInput.Text
        name="legalSupervisorPersonalId"
        label={t('input.label.personalId')}
        appBackground
        borderless
        fullWidth
      />
    </LabelFormStep>
  );
};

export default LabelSupervisorStep;
